import { Component, ElementRef, HostListener, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { SaveFormService } from "../services/save-form.service";
import { iinValidator } from "../../../../validators/iin.validator";
import { ApiService } from "src/app/services/api/api.service";
import { FormSelectModelDto } from "src/app/pages/payment-link-list/models/paylinks.model";
import { takeUntil } from "rxjs";
import { UnsubscribeService } from "src/app/services/unsubscribe.service";
import { hasDotValidator } from "../../../../validators/has-dot.validator";

@Component({
	selector: "app-company-data",
	templateUrl: "./company-data.component.html",
	styleUrls: ["./company-data.component.scss"],
	providers: [UnsubscribeService],
})
export class CompanyDataComponent implements OnInit {
	form!: FormGroup;

	isOpenSelect = false;

	companyName = "";
	phone = "";
	email = "";
	bin = "";
	type = "";

	typesCompany: FormSelectModelDto[] = [];

	constructor(
		private router: Router,
		private el: ElementRef,
		private saveFormService: SaveFormService,
		private apiService: ApiService,
		private unsubscribe$: UnsubscribeService
	) {}

	ngOnInit() {
		this.initForm();

		this.getActivityList()
			.pipe(takeUntil(this.unsubscribe$))
			.subscribe((res) => {
				this.typesCompany = res;
			});
	}

	@HostListener("document:click", ["$event"])
	onClick(event: Event) {
		if (this.el.nativeElement.contains(event.target)) {
			this.isOpenSelect = false;
		}
	}

	initForm(): void {
		if (localStorage.hasOwnProperty("form")) {
			this.companyName = this.saveFormService.getFormData().companyData.companyName;
			this.phone = this.saveFormService.getFormData().companyData.phone.substring(2);
			this.email = this.saveFormService.getFormData().companyData.email;
			this.bin = this.saveFormService.getFormData().companyData.bin;
			this.type = this.saveFormService.getFormData().companyData.type;
		} else {
			this.saveFormService.initFormLocalStorage();
		}

		this.form = new FormGroup({
			companyFormControl: new FormControl(this.companyName, [Validators.required]),
			phoneFormControl: new FormControl(this.phone, [Validators.required, Validators.minLength(10)]),
			emailFormControl: new FormControl(this.email, [Validators.required, Validators.email, hasDotValidator()]),
			binFormControl: new FormControl(this.bin, [Validators.required, Validators.minLength(12), iinValidator()]),
			companyTypeFormControl: new FormControl(this.type, [Validators.required]),
		});
	}

	get companyRequiredError() {
		return this.form.get("companyFormControl")?.hasError("required");
	}

	get phoneRequiredError() {
		return this.form.get("phoneFormControl")?.hasError("required");
	}

	get phoneFormatError() {
		return this.form.get("phoneFormControl")?.hasError("minlength");
	}

	get emailRequiredError() {
		return this.form.get("emailFormControl")?.hasError("required");
	}

	get emailFormatError() {
		return this.form.get("emailFormControl")?.hasError("email");
	}

	get binRequiredError() {
		return this.form.get("binFormControl")?.hasError("required");
	}

	get binFormatError() {
		return this.form.get("binFormControl")?.hasError("minlength");
	}

	get companyTypeRequiredError() {
		return this.form.get("companyTypeFormControl")?.hasError("required");
	}

	get dotEmailFormatError() {
		const emailForm = this.form.get("emailFormControl");
		return emailForm?.hasError("hasDotNotValid") || emailForm?.hasError("mailDotNotValid");
	}

	openSelect(event: MouseEvent) {
		event.stopPropagation();
		this.isOpenSelect = true;
	}

	setCompanyType(name: string) {
		this.form.patchValue({ companyTypeFormControl: name });
		this.isOpenSelect = false;
		this.saveData();
	}

	saveData() {
		const companyName = this.form.get("companyFormControl")?.value.trim();
		const phone = `+7${this.form.get("phoneFormControl")?.value.trim()}`;
		const email = this.form.get("emailFormControl")?.value.trim();
		const bin = this.form.get("binFormControl")?.value.trim();
		const type = this.form.get("companyTypeFormControl")?.value;

		this.saveFormService.saveCompanyData(companyName, phone, email, bin, type);
	}

	sendForm() {
		this.router.navigate(["/register/address-company"]);
	}

	getActivityList() {
		const url = `/reference/activity_type/filter`;
		return this.apiService.httpGet<FormSelectModelDto[]>(url);
	}
}
